// BFF: ○ gap — legacy states endpoint. Reference data, so no bff/crm module of its own.
export { useStates } from './StateService'
